export const normalizedPercentage = (percentage: number) => {
  return percentage > 1 ? percentage / 100 : percentage;
};

export const toDisplayPercentage = (percentage: number) => {
  return parseFloat(((percentage ?? 0) * 100).toFixed(2)).toString();
};

export const calculateBonusAmount = ({
  minPrice,
  percentage,
  country,
  publicationPrice,
}: {
  country: "CO" | "MX";
  minPrice: number;
  percentage: number;
  publicationPrice: number;
}): number => {
  const basePrice =
    minPrice && minPrice > 0 ? minPrice : publicationPrice * 0.97;

  const normalizedPercentage = percentage > 1 ? percentage / 100 : percentage;
  const rawAmount = normalizedPercentage * basePrice;

  if (country === "CO") {
    return Math.floor(rawAmount / 10000) * 10000;
  }

  if (country === "MX") {
    return Math.floor(rawAmount / 100) * 100;
  }

  return 0;
};
